<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-4.h6.basic800--text {{ $t('promo_banner') }}
        v-divider.basic300
        v-card-text.pa-0
          v-form(ref="form")
            v-card.pa-4(style="overflow-x: hidden;")
              label.mb-1.basic600--text.text-uppercase {{ $t('promo_description') }}
              v-textarea.mt-2(v-model="promoText" rows="3" auto-grow outlined dense persistent-hint :rules="rules.not_empty" counter :maxlength="200" background-color="basic200")
              v-layout.mt-4
                .p2.primary500--text.my-auto {{ $t('background_color') }}:
                v-spacer
                v-avatar.mx-2.my-auto(tile :color="backColor" size="18" style="border: 1px solid #757575")
                v-btn.my-auto.ml-1(color='textColorAccent' small outlined height=24 :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="pickBackgroundColor = true")
                  eva-icon.ml-n2.mt-1(name="plus-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="14" width="14")
                  .button-AA-tiny.textColorAccent--text {{ $t('pick_color') }}
              v-layout.mt-4
                .p2.primary500--text.my-auto {{ $t('text_color') }}:
                v-spacer
                v-avatar.mx-2.my-auto(tile :color="textColor" size="18" style="border: 1px solid #757575")
                v-btn.my-auto.ml-1(color='textColorAccent' small outlined height=24 :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="pickTextColor = true")
                  eva-icon.ml-n2.mt-1(name="plus-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="14" width="14")
                  .button-AA-tiny.textColorAccent--text {{ $t('pick_color') }}
              v-layout.mt-4
                .p2.primary500--text.my-auto {{ $t('publish_banner') }}
                v-spacer
                div
                  y-switch.my-auto.mr-n2.mb-n3(v-model="bannerStatus")
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='info500' dark depressed height=32 @click="clickSend" :loading="isLoading")
            .button-AA-small.basic100--text {{ $t('save') }}
    .modals
      color-picker(v-if="pickBackgroundColor" :open.sync="pickBackgroundColor" :color.sync="backColor" text="Select background color")
      color-picker(v-if="pickTextColor" :open.sync="pickTextColor" :color.sync="textColor" text="Select text color")
</template>

<script>
import { mapActions } from 'vuex'
import ColorPicker from '@/components/ColorPicker.vue'

export default {
  name: 'AddPromoBanner',
  components: { ColorPicker },
  props: ['open', 'settings', 'company'],
  data: () => ({
    promoText: null,
    bannerStatus: false,
    textColor: '#FFFFFF',
    backColor: '#5DA8DC',
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    },
    pickBackgroundColor: false,
    pickTextColor: false,
    isLoading: false
  }),
  watch: {
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    status () {
      return this.bannerStatus ? 'published' : 'draft'
    }
  },
  mounted () {
    if (this.settings.banner) {
      this.promoText = this.settings.banner.text
      this.backColor = this.settings.banner.backcolor
      this.textColor = this.settings.banner.textcolor
      if (this.settings.banner.status === 'published') {
        this.bannerStatus = true
      } else {
        this.bannerStatus = false
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSend() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      let data ={
        text: this.promoText,
        backcolor: this.backColor,
        textcolor: this.textColor,
        status: this.status
      }
      this.$axios.patch(`/store/settings/${this.company.slug}/`, { banner: data })
        .then(() => {
          this.showMessage(['success', this.$t('success_message.promo_banner_updated')])
          this.$emit('banner', data)
          this.showModal = false
        })
        .catch(() =>{
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>
